module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('admin-layout', [_c('div', {
    staticClass: "content",
    attrs: {
      "slot": "main"
    },
    slot: "main"
  }, [_c('div', {
    staticClass: "content-header"
  }, [_c('h3', [_vm._v("Fields "), _c('button', {
    staticClass: "btn btn-custom",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toogleShowFieldModal
    }
  }, [_vm._v("Add New "), _c('i', {
    staticClass: "fa fa-plus"
  })])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Field type")]), _vm._v(" "), _c('th', [_vm._v("Data type")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.fieldList), function(item) {
    return _c('tr', [_c('th', {
      staticClass: "field-label"
    }, [(item.is_editable) ? _c('a', {
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.toogleShowFieldModal(item)
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.is_editable) ? _c('a', {
      staticClass: "text-right",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeField(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()]), _vm._v(" "), _c('td', [(item.field_type == 'L') ? _c('span', {
      staticClass: "label label-info"
    }, [_vm._v("LEAD")]) : _vm._e(), _vm._v(" "), (item.field_type == 'C') ? _c('span', {
      staticClass: "label label-info"
    }, [_vm._v("CRM")]) : _vm._e(), _vm._v(" "), (item.field_type == 'calculated') ? _c('span', {
      staticClass: "label label-default"
    }, [_vm._v("CALCULATED")]) : _vm._e(), _vm._v(" "), (item.field_type == 'S') ? _c('span', {
      staticClass: "label label-default"
    }, [_vm._v("SYSTEM")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.data_type.name))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modals"
    },
    slot: "modals"
  }, [(_vm.showFieldModal) ? _c('field-modal', {
    attrs: {
      "field": _vm.field
    },
    on: {
      "close": _vm.closeFieldModal
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39473dc4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/FieldsSettings.vue
// module id = 641
// module chunks = 0